import { useTranslation } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { TranslationsKeys, } from '../variable-interface';
import styles from './delete-confirmation-modal.module.scss';
export const DeleteConfirmationModal = ({ name, isModalOpen, onDeleteConfirm, onDeleteModalClose, isMultiSelected, selectedCount = 0, }) => {
    const { t } = useTranslation();
    const getModalTitle = () => {
        if (isMultiSelected) {
            return t(TranslationsKeys.MODAL_DELETE_TITLE, {
                count: selectedCount,
            });
        }
        return t(TranslationsKeys.MODAL_DELETE_TITLE);
    };
    const getModalMessage = () => {
        if (isMultiSelected) {
            return t(TranslationsKeys.MODAL_DELETE_MULTI_MESSAGE, {
                count: selectedCount,
            });
        }
        return t(TranslationsKeys.MODAL_DELETE_MESSAGE, { name });
    };
    return (React.createElement(Modal, { isOpen: isModalOpen, size: ModalSize.XSMALL, title: getModalTitle(), confirmButton: {
            text: t('alert.delete.text'),
            onConfirm: onDeleteConfirm,
        }, dismissButton: {
            text: t('Cancel'),
        }, onDismiss: onDeleteModalClose },
        React.createElement(Vertical, { className: styles.modalContent },
            React.createElement(Typography, { variant: "content-label-subhead", color: Colors.base, className: styles.modalMessage }, getModalMessage()))));
};
//# sourceMappingURL=delete-confirmation-modal.js.map